var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8828 10.8828C16.3711 10.3945 16.3711 9.60156 15.8828 9.11328L8.38281 1.61328C7.89453 1.125 7.10156 1.125 6.61328 1.61328C6.125 2.10156 6.125 2.89453 6.61328 3.38281L13.2305 10L6.61719 16.6172C6.12891 17.1055 6.12891 17.8984 6.61719 18.3867C7.10547 18.875 7.89844 18.875 8.38672 18.3867L15.8867 10.8867L15.8828 10.8828Z",
    fill: "#f4fdfa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.32993277fa70de9a2ebf28ddcd41ea8e.svg";
export { ForwardRef as ReactComponent };